<div class="sc-page">
    <p class="sc-title">Select Company</p>

    <hr class="sc-divider">

    <div class="sc-grid">
        <!-- Loading spinner -->
        <div *ngIf="!companyData" class="sc-loader">
            <mat-spinner diameter="36"></mat-spinner>
        </div>

        <!-- Company cards -->
        <ng-container *ngIf="companyData">
            <div class="sc-card" *ngFor="let companyDetails of companyData"
                (click)="navigateToDetailsPage(companyDetails?.org_id, companyDetails?.org_image_link, companyDetails?.user_id)">
                <img [src]="companyDetails?.org_image_link || '../../../../../../assets/images/company.png'"
                    class="sc-org-img" alt="company">
                <p class="sc-org-name">{{ companyDetails?.org_name }}</p>
            </div>

            <!-- No data -->
            <p *ngIf="companyData.length === 0" class="sc-empty">No Company found.</p>
        </ng-container>
    </div>

    <!-- Or divider + Add New -->
    <div class="sc-or-row">
        <div class="sc-or-line"></div>
        <span class="sc-or-text">Or</span>
        <div class="sc-or-line"></div>
    </div>

    <div class="sc-add-btn-wrap">
        <app-add-action-button routerLink="/company-register" [btnName]="'Add A New Company'" [isSvgShow]="true">
        </app-add-action-button>
    </div>
</div>